import { Copy } from "lucide-react";
import * as React from "react";

import { Button } from "@/components/ui/button";

/**
 * Il link d'accesso appena coniato, con un bottone per copiarlo.
 *
 * Vive qui e non dentro una pagina perché **il link è la garanzia, la mail è la comodità**
 * (ADR-0082 D2): ogni superficie che aggiunge un arco — partner, staff, e la prossima —
 * deve poterlo mostrare, altrimenti con l'SMTP muto l'invito è partito e nessuno sa dove.
 * Due copie di questo componente sarebbero due copie di quella promessa, e una delle due
 * prima o poi smetterebbe di mostrarlo.
 */
export function ClaimLink({ url }: { url: string }) {
  const [copied, setCopied] = React.useState(false);
  return (
    <div className="flex items-center gap-2">
      <code className="min-w-0 flex-1 truncate rounded border border-border/60 bg-elevated px-2 py-1.5 text-xs">
        {url}
      </code>
      <Button
        size="sm"
        variant="ghost"
        onClick={() => {
          void navigator.clipboard?.writeText(url);
          setCopied(true);
        }}
      >
        <Copy className="h-4 w-4" strokeWidth={1.5} />
        {copied ? "Copiato" : "Copia"}
      </Button>
    </div>
  );
}
